import React from 'react';
import Candlestick from './candlestick'

export default class GraphBody extends React.Component {
    static defaultProps = { multiplier: 20 };

    render() {
        let x = 1;
        return this.props.data.map((chunk, i) => {
            return (<Candlestick key={i} x={this.props.x} y={this.props.y + this.props.bot} xPos={x++} data={chunk} multiplier={this.props.multiplier}/>)
        });
    }
}


// WEBPACK FOOTER //
// ./src/graph-components/graph-body.js